const light = {
  title: 'light',

  colors: {
    primary: '#6e61c6',
    secondary: '#ffffff',
    tertiary: '#f5f5f5',

    white: '#ffffff',
    black: '',
    gray: '#adafca',
    darkGray: '#293249',

    danger: '',
    success: '#03bb85',
    info: '#5753e4',
    warning: '#ff6961',

    textColor: '#3e3f5e',
    secundaryTextColor: '#3e3f5e',

    bgContent: '#f8f8fb',
    bgBox: '#ffffff',
    bgAnimation: '#eaedf1',
    shadowBox: '0 0 40px 0 rgba(94,92,154,.06)',

    bgBoxMenu: '#ffffff',
    shadowMenu: '3px 5px 30px 0 rgba(94,92,154,.12)',

    shadowAlternative: 'none',

    timelineColor: '#6e61c6',

    textAreaWizColor: '#fcfcfd',
  }
};

export default light;
